import { Map } from "immutable";

import {
  composeSelectorCreator,
  composeSelectors
} from "seneca-common/utils/selectors/compose-selectors";

import SessionModule from "../../../../models/SessionModule";
import * as moduleSelectors from "./module";

export type State = Map<string, SessionModule>;

export function getModule(state: State, moduleId: string): SessionModule {
  return state.get(moduleId)!;
}

export const {
  getContentModuleId,
  getContentId,
  getModuleType,
  getContent,
  getTestingActive,
  getTimeStarted,
  getTimeFinished,
  getModuleState,
  getCompleted,
  getSubmitted,
  getGaveUp,
  getUserAnswer,
  getScore,
  wasCorrect,
  wasIncorrect,
  moduleStillInProgress,
  moduleContainsGIF
  // @ts-ignore
} = composeSelectors(getModule, moduleSelectors);

export const createScoreSelector = composeSelectorCreator(
  // @ts-ignore
  getModule,
  moduleSelectors.createScoreSelector
);

export function isModuleInitialised(state: State, moduleId: string): boolean {
  return !!getModule(state, moduleId);
}
